import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { gradientStyle, headingStyles } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  display: block;
`;
const Title = styled.h2 `
  ${headingStyles};
  font-size: ${fluidAdjusted(32, 64)};
  line-height: ${fluidAdjusted(40, 110)};
  --titleColor: ${brand.secondary.red5};
  color: var(--titleColor);

  &::before {
    top: 16px;
  }

  &[data-title-theme='mid'] {
    --titleColor: ${brand.secondary.red3};
  }

  &[data-title-theme='light'] {
    --titleColor: ${brand.secondary.red1};
  }

  &[data-line-position='left'][data-title-theme='gradient'] {
    ${gradientStyle};
    &::before {
      content: '';
      height: 4px;
      width: 20px;
      background-color: ${brand.secondary.red5};
      position: absolute;
      right: calc(100% + 10px);
      border-radius: 0 2px 2px 0;

      @media ${from(Device.TabletSmall)} {
        top: ${fluidAdjusted(17, 60)};
      }

      @media ${from(Device.TabletLarge)} {
        height: 6px;
        width: 72px;
        top: ${fluidAdjusted(20, 56)};
        right: calc(100% + 20px);
        border-radius: 0 3px 3px 0;
      }

      @media ${from(Device.DesktopLarge)} {
        top: ${fluidAdjusted(20, 56)};
        right: calc(100% + 40px);
      }
    }
  }

  &[data-line-position='right'][data-title-theme='gradient'] {
    ${gradientStyle};
    &::after {
      content: '';
      height: 4px;
      width: 20px;
      background-color: ${brand.secondary.red1};
      position: absolute;
      left: calc(100% + 10px);
      border-radius: 2px 0 0 2px;

      @media ${from(Device.TabletLarge)} {
        height: 6px;
        width: 72px;
        top: 55px;
        left: calc(100% + 40px);
        border-radius: 3px 0 0 3px;
      }
    }
  }
`;
const SectionTitleStyles = {
    Container,
    Title,
};
export default SectionTitleStyles;
